import EffectsContainer from "./EffectsContainer";

export default EffectsContainer;
